<template>
  <div class="time-range-selector">
    <div v-if="timeRanges.length === 0">Нет слотов</div>
    <div v-else class="time-range-selector-container">
      <div class="time-range-selector-title">
        Время заказа
      </div>
      <select v-model="selectedTimeRange" id="time-range-selector" class="time-range-selector-controller">
        <option v-for="(range, index) in timeRanges" :key="index" :value="range">
          {{ range }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dateStart: {
      type: String,
      required: true
    },
    dateFinish: {
      type: String,
      required: true
    },
    storedTimeRange: {
      type: String
    }
  },
  data() {
    return {
      selectedTimeRange: '',
      timeRanges: []
    };
  },
  created() {
    this.generateTimeRanges();
    if(this.storedTimeRange !== null){
      this.selectedTimeRange = this.storedTimeRange;
    }
  },
  methods: {
    generateTimeRanges() {
      const start = new Date(this.dateStart);
      const end = new Date(this.dateFinish);
      const timeInterval = 30;
      const ranges = [];

      if (start.getMinutes() % timeInterval !== 0) {
        start.setMinutes(Math.ceil(start.getMinutes() / timeInterval) * timeInterval);
      }

      while (start < end) {
        const nextStart = new Date(start.getTime() + timeInterval * 60000);
        if (nextStart <= end) {
          const range = `${this.formatTime(start)} - ${this.formatTime(nextStart)}`;
          ranges.push(range);
        }
        start.setMinutes(start.getMinutes() + timeInterval);
      }
      this.timeRanges = ranges;
      this.$emit('slotsChanged', ranges);
    },
    formatTime(date) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
  },
  watch: {
    selectedTimeRange: function (value) {
      this.$emit('selectTime', value);
    },
    dateStart: function () {
      this.timeRanges = [];
      this.generateTimeRanges();
    }
  }
};
</script>

<style scoped lang="scss">
  .time-range-selector{
    &-container{
      display: flex;
      gap: 8px;
      align-items: center;
    }

    &-title{
      font-weight: 500;
      line-height: 14px;
      font-size: 14px;
    }

    &-controller{
      padding: 8px;
      width: 100%;
    }
  }
</style>
